import React, { useEffect, useState } from "react";
import classes from "./SuppliersLedger.module.css";
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import { Pencil, Trash2, Printer } from "lucide-react";
import Swal from "sweetalert2";
import Select from 'react-select';
import RotatingLogo from '../../../Assets/rotating-logo.png'


const SuppliersLedger = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedSupplierName, setSelectedSupplierName] = useState("");
  const [selectedSupplierId, setSelectedSupplierId] = useState("");
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [amountToBePaidInput, setAmountToBePaidInput] = useState("");
  const [customerLedgers, setCustomerLedgers] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [showLedgerButton, setShowLedgerButton] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");  
  const [currentMonth, setCurrentMonth] = useState('');
  const [bearer, setBearer] = useState('');
  const [user, setUser] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [fetchingLoading, setFetchingLoading] = useState(false);
  const [GenLedger, setGenLedger] = useState([]);


    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
        const current = await localStorage.getItem('currentMonth');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
      if (current !== null) {
        console.log(current)
        const date = new Date(current);  // Assume current is in a parsable date format

        setCurrentMonth(date);
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        // Set the min and max date for the date input

        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');  // Add leading zero
          const day = String(date.getDate()).padStart(2, '0');         // Add leading zero
          return `${year}-${month}-${day}`;
      };
        
        setMinDate(formatDate(startOfMonth));
        setMaxDate(formatDate(endOfMonth));

       console.log(formatDate(startOfMonth), formatDate(endOfMonth));

      }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  // ===== Helpers =====
  const formatMoney = (value) => {
    const num = Number(value || 0);
    return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
  };
  const formatIntegerWithCommas = (digits) => {
    if (!digits) return "";
    const n = Number(digits);
    if (isNaN(n)) return "";
    return n.toLocaleString("en-NG", { maximumFractionDigits: 0 });
  };

  const getPaymentStatus = (debtAmount, totalAmount) => {
    const debtNum = parseFloat(debtAmount || 0);
    const totalNum = parseFloat(totalAmount || 0);

    if (debtNum === 0) return { status: "Paid", className: "statusPaid" };
    if (debtNum === totalNum) return { status: "Owing", className: "statusOwing" };
    return { status: "Paid Part", className: "statusPartialPaid" };
  };
  const [modalData, setModalData] = useState({
    invoiceNumber: "",
    customerName: "",
    totalAmount: 0,
    subTotal: 0,
    outstandingBalance: 0,
    amountToBePaid: 0,
    description: "",
    transactionDate: "",
  });

  const openEditModal = (invoice) => {
    // Add null/undefined checks
    if (!invoice) {
      console.error("Invoice is undefined or null");
      return;
    }

    setSelectedInvoice(invoice);
    setModalData({
      invoiceNumber: invoice?.invoice_number || invoice?.uuid || "",
      customerName:
        invoice?.customer?.name ||
        `Customer ${invoice?.customer_id || "Unknown"}` ||
        "",
      totalAmount: parseFloat(invoice?.total_price || invoice?.amount || 0),
      subTotal: parseFloat(invoice?.sub_total || 0),
      outstandingBalance: parseFloat(invoice?.debit || invoice?.balance || 0),
      amountToBePaid: 0,
      description: invoice?.description || "",
      transactionDate: invoice?.transaction_date || "",
    });
    setAmountToBePaidInput("");

    setIsEditModalOpen(true);
  };
  const handleModalInputChange = (field, value) => {
    setModalData((prev) => {
      let updated = { ...prev };

      if (field === "amountToBePaid") {
        const digitsOnly = String(value || "").replace(/\D/g, "");
        setAmountToBePaidInput(digitsOnly);
        const parsed = digitsOnly ? parseInt(digitsOnly, 10) : 0;
        updated.amountToBePaid = parsed;
        const originalBalance = parseFloat(
          selectedInvoice?.debit || selectedInvoice?.balance || 0
        );
        const newBalance = Math.max(0, originalBalance - parsed);
        updated.outstandingBalance = newBalance;
        return updated;
      }

      updated[field] = value;

      // If amount to be paid changes, calculate new outstanding balance
      // (Handled above with formatted parsing)

      return updated;
    });
  };

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };




  // ===== Fetch Suppliers =====
 const handleCustomerChange = (selectedOption) => {
  setSelectedCustomer(selectedOption.value);
setSelectedSupplierName(selectedOption.label);
  // reset ledgers + details whenever a new customer is picked
  setCustomerLedgers([]);
  setGenLedger([]);
  setCustomerDetails(null);
};

useEffect(() => {
  if (selectedCustomer) {
    fetchAccounts(selectedCustomer);
  }
}, [selectedCustomer]);

  //   useEffect(() => {
  //     const fetchCustomersLedger = async () => {
  //       const token = localStorage.getItem("authToken");
  //       setCustomerLoading(true);
  //       try {
  //         const res = await axios.get(`${BASE_URL}/v1/customer/get-customer-ledger`, {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         });
  //         const customerData = res.data?.data?.data || res.data?.data || [];
  //         setCustomers(customerData);
  //       } catch (err) {
  //         console.error("Error fetching customer's Ledger:", err);
  //       } finally {
  //         setCustomerLoading(false);
  //       }
  //     };
  //     fetchCustomersLedger();
  //   }, []);


  // ===== Merge Invoice Counts =====
  const calculateMonthlyInvoices = async (customer) => {
    if (!customer?.id) return;

    const token = localStorage.getItem("authToken");
    try {
      // Fetch invoices for selected customer from fetch-sales-invoice
      const response = await axios.get(`${BASE_URL}/v1/fetch-sales-invoice`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const allInvoices = response.data?.data || [];
      const customerInvoices = allInvoices.filter(
        (inv) => String(inv.customer_id) === String(customer.id)
      );

      // Filter invoices for current month
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear();

      const monthlyInvoices = customerInvoices.filter((inv) => {
        const invDate = new Date(inv.transaction_date);
        return (
          invDate.getMonth() === currentMonth &&
          invDate.getFullYear() === currentYear
        );
      });

      // Ledger invoices (from customer endpoint)
      const ledgerInvoices = (customer.ledgers || []).length;

      // Merge counts
      return monthlyInvoices.length + ledgerInvoices;
    } catch (err) {
      console.error("Error calculating monthly invoices:", err);
      return 0;
    }
  };

  const handleProcess = async () => {
    setProcessing(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // any API call logic here
    } catch (err) {
      console.error(err);
    } finally {
      setProcessing(false);
      setShowLedgerButton(true);
    }
  };

    const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      console.log(response);
      setTableData(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchCharts();

    }
  }, [bearer]);


    const fetchAccounts = async () => {
    setFetchingLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary/supplier-ledger-matrix`, {
        params: {
          supplier_id: selectedCustomer,
          // start_date: selectedDate,
          // end_date: selectedEndDate,
        },
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearer}`
        }
      });
      const resultsss = response.data?.data?.ledger;
      const resultS = response.data?.data;
      setCustomerLedgers(resultsss);
      setGenLedger(resultS);
   
      console.log(response, "ksfjkls");

    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);

      }
    } finally {
      setFetchingLoading(false);
    }
  };

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <div className={classes.actions}>
          <button
            className={classes.btns}
            onClick={() => navigate("/transactions/receivables/sales")}
          >
            Sales Invoice
          </button>
          <button
            className={classes.btns}
            onClick={() => navigate("/inventory/purchaseOrder")}
          >
            Purchase Invoice
          </button>
          <button className={classes.btns_ss0}>Supplier Ledger</button>
          <button
            className={`${classes.btns} ${classes.greens}`}
            onClick={() => navigate("/settings/product-services")}
          >
            Product & Services
          </button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Supplier Ledger</h2>
          <h1 className={classes.Titles}>
            Manage your sales transactions, invoices, and customer payments.
          </h1>
        </header>

              <div className="form-group row" style={{ marginTop: 15 }}>
                {/* <label htmlFor="example-text-input" className="col-sm-5 col-form-label font-weight-400">Supplier:</label> */}
                <div className="col-sm-3" >
                  <Select
                    onChange={handleCustomerChange}
                    options={tableData}
                    placeholder="Select a Supplier" 
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        maxWidth: '300px',
                        overflowY: 'auto',
                      }),
                        option: (provided) => ({
                          ...provided,
                          fontSize: "13px",
                          padding: "6px 10px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          fontSize: "13px",
                        }),
                        input: (provided) => ({
                          ...provided,
                          fontSize: "13px",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          fontSize: "13px",
                          color: "#999",
                        }),
                      }}
                  />
                </div>
                <div className="col-sm-3">
                  {customerLedgers.length > 0 && (
                    <button
                      type="button"
                      className={classes.btnssd}
                      onClick={() => {
                        console.log("Ledger opened");
                        navigate("/accounting/suppliers_personal_ledgers", {
                          state: {
                            customerName: selectedSupplierName,
                            customerId: selectedSupplierId,
                            // Pass the complete supplier details
                            customerDetails: {
                              ...customerDetails,
                              ledgers: customerLedgers, // Pass the fetched ledger data
                            },
                            // Pass the ledger data as filteredInvoices for compatibility
                            filteredInvoices: customerLedgers.map(ledger => ({
                              id: ledger.id,
                              invoice_number: ledger.invoice_number || ledger.uuid,
                              uuid: ledger.uuid || ledger.invoice_number,
                              transaction_date: ledger.transaction_date || ledger.created_at?.split("T")[0],
                              created_at: ledger.created_at,
                              description: ledger.description,
                              total_price: ledger.balance || 0,
                              amount: ledger.balance || 0,
                              debit: ledger.debit || 0,
                              balance: ledger.balance || 0,
                              credit: ledger.credit || 0,
                              customer_id: selectedSupplierId,
                              customer: {
                                name: selectedSupplierName,
                                id: selectedSupplierId
                              }
                            })),
                            // Pass the calculated totals
                            totalSales: customerDetails?.totalSales || 0,
                            totalPaid: customerDetails?.totalPaid || 0,
                            totalOutstanding: customerDetails?.totalOutstanding || 0,
                            totalInvoices: customerDetails?.totalInvoices || customerLedgers.length,
                          },
                        });
                      }}
                    >
                      View Personal Ledger
                    </button>
                  )}

                </div>
              </div>
        <div className={classes.actionsRight}>
              {/* <input
                list="supplier-list"
                placeholder={customerLoading ? "Fetching supplier..." : "Search or select supplier"}
                value={selectedSupplierName}
                onChange={async (e) => {
                  const value = e.target.value;
                  setSelectedSupplierName(value);

                  // Find supplier (case-insensitive, trimmed)
                  const match = customers.find(
                    (c) => c.name.toLowerCase().trim() === value.toLowerCase().trim()
                  );

                  if (match) {
                    setSelectedSupplierId(match.id);

                    setLedgerLoading(true);
                    try {
                      const token = localStorage.getItem("userToken");
                      const res = await axios.get(`${BASE_URL}/beneficiary`, {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          Accept: "application/json",
                        },
                        params: { supplier_id: match.id },
                      });

                      const ledgerData = res.data.data || [];

                      // Attach supplier name to each ledger item
                      const ledgerWithName = ledgerData.map((ledger) => ({
                        ...ledger,
                        supplierName: match.name,
                      }));

                      setCustomerLedgers(ledgerWithName);

                      // Update summary cards
                      const totalSales = ledgerWithName.reduce(
                        (sum, entry) => sum + parseFloat(entry.balance || 0),
                        0
                      );
                      const totalPaid = ledgerWithName.reduce(
                        (sum, entry) => sum + parseFloat(entry.credit || 0),
                        0
                      );
                      const totalOutstanding = ledgerWithName.reduce(
                        (sum, entry) => sum + parseFloat(entry.debit || 0),
                        0
                      );

                      setCustomerDetails({
                        ...match,
                        totalSales,
                        totalPaid,
                        totalOutstanding,
                        totalInvoices: ledgerWithName.length,
                      });
                    } catch (error) {
                      console.error("Failed to fetch supplier ledger:", error);
                      setCustomerLedgers([]);
                      setCustomerDetails(null);
                    } finally {
                      setLedgerLoading(false);
                    }
                  } else {
                    setSelectedSupplierId("");
                    setCustomerLedgers([]);
                    setCustomerDetails(null);
                  }
                }}
              />

              <datalist id="supplier-list">
                {customers.map((c) => (
                  <option key={c.id} value={c.name} />
                ))}
              </datalist> */}
            {/* <div className={classes.inputWrapperd}>
              <button
                type="button"
                disabled={processing}
                onClick={handleProcess}
                className={classes.btnssd}
              >
                {processing ? "Processing..." : "Process"}
              </button>
            </div> */}
        </div>

        {/* Stats */}
        {/* {customerDetails && ( */}
        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total sales</p>
                <p className={classes.kdptg1}>
                  ₦{GenLedger?.total_sales || 0}
                </p>
                <div className={classes.rvnue}>
                  <p>This month</p>
                </div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Paid</p>
                <p className={classes.kdptg2}>
                  ₦{GenLedger?.total_paid || 0}
                </p>
                <div className={classes.rvnue}>
                  <p>Debt Cleared</p>
                </div>
              </div>
            </div>
            <div className={classes.fiftkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Outstanding</p>
                <p className={classes.kdptg3}>
                  ₦{GenLedger?.total_outstanding || 0}
                </p>
                <div className={classes.rvnue}>
                  <p>Total Credit</p>
                </div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>This month</p>
                <p className={classes.kdptg4}>
                  {GenLedger?.total_invoices || 0}
                </p>
                <div className={classes.rvnue}>
                  <p>Total invoices</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* )} */}

        {/* Invoices Table */}
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>S/N</th>
                <th>Transaction Date</th>
                <th>Invoice Number</th>
                <th>Description</th>
                <th>Total Amount</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Status</th>
                {/* <th>Sales Type</th> */}
                <th>Post Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {fetchingLoading ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    Loading...
                  </td>
                </tr>
              ) : customerLedgers.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center", padding: "20px" }}>
                    {selectedCustomer
                      ? "No sales found for this customer."
                      : "Select Supplier To See Supplier Data."}
                  </td>
                </tr>
              ) : (
                customerLedgers.map((item, index) => {
                  const currentDebt = parseFloat(item.debit || item.balance || 0);
                  const currentCredit = parseFloat(item.credit || 0);
                  const totalAmount = parseFloat(item.balance || 0);
                  const paymentStatus = getPaymentStatus(currentDebt, totalAmount);

                  return (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      {/* <td>{item.transaction_date || "—"}</td> */}
                      <td>{item.created_at?.split("T")[0] || "—"}</td>
                      <td>{item.invoice_number || item.uuid || "—"}</td>
                      <td>{item.description || "—"}</td>
                      <td style={{ textAlign: "right" }}>₦{formatMoney(totalAmount)}</td>
                      <td style={{ textAlign: "right" }}>₦{formatMoney(currentDebt)}</td>
                      <td style={{ textAlign: "right" }}>₦{formatMoney(currentCredit)}</td>
                      <td>
                        <span className={classes[paymentStatus.className]}>
                          {paymentStatus.status}
                        </span>
                      </td>
                      {/* <td>
            <span
              className={
                item.sales_type === "cash"
                  ? classes.statusCash
                  : classes.statusCredit
              }
            >
              {item.sales_type === "cash" ? "Cash" : "Credit"}
            </span>
          </td> */}
                      <td>{item.created_at?.split("T")[0] || "—"}</td>
                      <td className={classes.actionsIcons}>
                        <Pencil
                          size={16}
                          style={{ color: "rgba(22, 163, 74, 1)", cursor: "pointer" }}
                          onClick={() => openEditModal(item)}
                        />
                        <Trash2 size={16} style={{ color: "rgb(255, 2, 2)", margin: "0 6px" }} />
                        <span
                          onClick={() =>
                            navigate("/reportinvoice", { state: { invoice: item } })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <Printer
                           size={16} 
                           style={{ color: " rgba(37, 99, 235, 1)", cursor: "pointer" }} />
                        </span>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>

          </table>

          
        </div>
      </div>
{fetchingLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}

      {/* <Footer /> */}
    </div>
  );
};

export default SuppliersLedger;